import { IFactSource, ISource, IChartLookup } from 'shared/interfaces'
import { configKeysMap } from './chartConfig'

export const filterFactSources = (factSources: IFactSource[], countryCode: string): ISource[] =>
  factSources
    .flatMap((factSource) => factSource.sources.map((source) => ({ ...source, origin: factSource.origin })))
    .filter((source) => source.country_code === countryCode)
    .sort(sortFactSources)

export const sortFactSources = <T extends ISource | IChartLookup>(sourceA: T, sourceB: T) => {
  if (sourceA.chart !== sourceB.chart) {
    const sourceAKey = sourceA.chart.split('_')[0]
    const sourceBKey = sourceB.chart.split('_')[0]

    if (!configKeysMap.includes(sourceAKey)) return 1
    if (!configKeysMap.includes(sourceBKey)) return -1

    return configKeysMap.indexOf(sourceAKey) - configKeysMap.indexOf(sourceBKey)
  }
  return sourceA.configuration === 'single' ? -1 : 1
}
